import { PluralPipe } from '../../pipes/plural.pipe';
import { TFeedbackComparisonChange, TFeedbackComparisonConfig } from './rid-feedback-comparison-toast';

const pluralPipe = new PluralPipe();

function formatCount(value: number, singular: string, plural: string): string {
  return `${value} ${pluralPipe.transform(value, singular, plural)}`;
}

function formatCountDescription(
  change: TFeedbackComparisonChange,
  difference: number,
  singular: string,
  plural: string,
  equalLabel: string,
): string {
  if (change === 'EQUAL') return `Dat is ${equalLabel} als vorige keer!`;

  const formattedDifference = formatCount(difference, singular, plural);
  return change === 'HIGHER'
    ? `Dat is ${formattedDifference} meer dan vorige keer!`
    : `Dat is ${formattedDifference} minder dan vorige keer.`;
}

export const ACCURACY_COMPARISON: TFeedbackComparisonConfig = {
  better: 'HIGHER',
  formatTitle: (value) => `${['Enkele goed', 'Gedeelte goed', 'Merendeel goed', 'Bijna alles goed', 'Alles goed'][value]}!`,
  formatDescription: (change) => {
    if (change === 'EQUAL') return 'Dat is even nauwkeurig als vorige keer!';
    return change === 'HIGHER' ? 'Dat is nauwkeuriger dan vorige keer!' : 'Dat is minder nauwkeurig dan vorige keer.';
  },
};

export const WORD_COUNT_COMPARISON: TFeedbackComparisonConfig = {
  better: 'HIGHER',
  formatTitle: (value) => `${formatCount(value, 'woord', 'woorden')}!`,
  formatDescription: (change, difference) => formatCountDescription(change, difference, 'woord', 'woorden', 'even veel'),
};

export const DURATION_COMPARISON: TFeedbackComparisonConfig = {
  better: 'LOWER',
  formatTitle: (value) => `${formatCount(value, 'seconde', 'seconden')}!`,
  formatDescription: (change, difference) => formatCountDescription(change, difference, 'seconde', 'seconden', 'even snel'),
};
